// extracted by mini-css-extract-plugin
module.exports = {"containerPatientPlanning":"PatientPlanningView_containerPatientPlanning__2X-43"};